module.exports = __webpack_public_path__ + "img/community.c143b743.png";